import { render, staticRenderFns } from "./VersionIos.vue?vue&type=template&id=32ad7fb1&scoped=true"
import script from "./VersionIos.vue?vue&type=script&lang=js"
export * from "./VersionIos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ad7fb1",
  null
  
)

export default component.exports